// extracted by mini-css-extract-plugin
export default {"panel":"FlowOption_panel__FLaWE","vertical":"FlowOption_vertical__4Htkv","active":"FlowOption_active__iWS3F"};